<template>
 <ion-page>
		<!--<spot-header :title="pageTitle + ' ' + (!tablesData || !tablesData.currentProject ? '' : tablesData.currentProject.name)" :canGoHome="false && !isWaitingItems" :canGoBack="false && !isWaitingItems" @pressedGoHome="$router.push('/home')" @pressedGoBack="exitSupply"></spot-header>-->
		<spot-header :title="(!isPicking ? supplyTitle : pickingTitle) + ' ' + (!tablesData || !tablesData.currentProject ? '' : tablesData.currentProject.name)" :canGoHome="false && !isWaitingItems" :canGoBack="false && !isWaitingItems" @pressedGoHome="$router.push('/home')" @pressedGoBack="exitSupply"></spot-header>

		<ion-content :fullscreen="true"> <!--v-if="isActive"-->
			<ion-progress-bar type="indeterminate" v-if="!isActive"></ion-progress-bar>
			<div id="actionArea" v-else>
				<web-socket-reader crReplacedChar="|" @readedBarcode="onReadedBarcode" @readedTag="onReadedTag" @readerError="onReaderError"></web-socket-reader>
				<ion-label color="tertiary" v-if="isWaitingItems">{{isWaitingItemsText}}</ion-label>
				<div class="flex-row-center-container">
					<spot-button
						fill="outline"
						size="small"
						color="danger"
						:enabled="true && !isWaitingItems"
						:expand="null"
						:text="suspendText"
						@clicked="exitSupply()">
					</spot-button>
					<spot-button
						fill="outline"
						size="small"
						color="success"
						:enabled="true && !isWaitingItems"
						:expand="null"
						:text="closeText"
						@clicked="closeSupply()">
					</spot-button>
				</div>
				<ion-item>
					<spot-input
						:ref="fields[field.search].name"
						:label="fields[field.search].text"
						:allignLabel="fields[field.search].allignLabel"
						:required="fields[field.search].required"
						:placeholder="fields[field.search].placeholder"
						:enabled="true"
						:value="fields[field.search].value"
						:type="fields[field.search].inputType"
						:clearInput="true"
						@textChanged="changedSearch">
					</spot-input>
					<ion-button v-if="!isPicking && !isWaitingItems" size="default" slot="end" disabled="true" @click="createNewPickAndProjectRowFromItems(null)">
						<ion-icon :icon="duplicate" slot="start" size="default"></ion-icon>
						{{ newItemText }}
					</ion-button>
				</ion-item>
				<ion-progress-bar type="indeterminate" v-if="!tablesData.picks"></ion-progress-bar> <!-- v-if="!tablesData.projectRows" -->
				<EasyDataTable
					:headers="headers"
					:items="tablesData.picks"
					:sort-by="sortBy"
					:sort-type="sortType"
					:search-field="searchFields"
					:search-value="fields[field.search].value"
					:empty-message="noItemsText"
					:body-row-class-name="bodyRowClassNameFunction"
					@click-row="tableItemClicked"
					multi-sort> <!-- :items="tablesData.projectRows" :body-item-class-name="bodyItemClassNameFunction" show-index alternating @click-row="editExistingProjectRow" -->
					<template #item-actions="pick">
						<!--
						<ion-button disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="showExistingPick(pick)">
							<ion-icon :icon="reader" slot="end" size="small"></ion-icon>
						</ion-button>
						<ion-button :color="pick.quantity_detected == pick.quantity ? 'success' : (pick.quantity_detected == 0 ? 'danger' : (pick.quantity_detected < pick.quantity ? 'warning' : 'tertiary'))" disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="editExistingPick(pick)">
							<ion-icon :icon="brush" slot="end" size="small"></ion-icon>
						</ion-button>
						-->
						<ion-button :disabled="isPicking && pick.project_rows.length == 0" color="dark" fill="outline" shape="round" size="small" slot="icon-only" @click="openAlert(pick)"> <!-- @click="deleteProjectRowsInPick(pick)" @click="deleteExistingPick(pick)" -->
							<ion-icon :icon="trash" slot="end" size="small"></ion-icon>
						</ion-button>
					</template>
					<!--
					<template #item-actions="projectRow">
						<ion-button disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="showExistingProjectRow(projectRow)">
							<ion-icon :icon="reader" slot="end" size="small"></ion-icon>
						</ion-button>
						<ion-button :color="pick.quantity_detected == pick.quantity ? 'success' : (pick.quantity_detected == 0 ? 'danger' : (pick.quantity_detected < pick.quantity ? 'warning' : 'tertiary'))" disabled=false fill="outline" shape="round" size="small" slot="icon-only" @click="editExistingProjectRow(projectRow)">
							<ion-icon :icon="brush" slot="end" size="small"></ion-icon>
						</ion-button>
						<ion-button disabled=true fill="outline" shape="round" size="small" slot="icon-only" @click="deleteExistingProjectRow(projectRow)">
							<ion-icon :icon="trash" slot="end" size="small"></ion-icon>
						</ion-button>
					</template>
					-->
					<template #expand="item">
						{{item.quantity}} {{item.item.measure_unit.name}} | {{item.item.location.name}} | Note {{(!item.notes)? '-': item.notes}}
					</template>
				</EasyDataTable>
				<ion-modal class="modal-settings" ref="modal" backdrop-dismiss="false" :is-open="isOpenModal" @didDismiss="modalDismissed">
					<ion-content>
						<ion-toolbar>
							<ion-title> {{ modalTitle }}</ion-title>
						</ion-toolbar>
							<div lines="none" v-for="field in pickContents" :key="field.id" class="no-pad">
							<spot-input
								v-if="(field.inputType == 'text' || field.inputType == 'number')"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:placeholder="getPlaceHolder(field)"
								:enabled="field.enabled"
								:validationState="field.validationState"
								:furtherInfo="field.furtherInfo"
								:value="field.value"
								:type="field.inputType"
								@textChanged="changedTextField(field.id, $event)">
							</spot-input>
							<ion-textarea
								v-if="field.inputType == 'area'"
								:ref="field.name"
								:placeholder="getPlaceHolder(field)"
								:required="field.required"
								:disabled="!field.enabled"
								:auto-grow="true"
								:value="field.value">
							</ion-textarea>
							<spot-checkbox
								v-if="field.inputType == 'check'"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:enabled="field.enabled"
								:validationState="field.validationState"
								:value="field.value"
								@checkboxChanged="changedCheckboxField(field.id, $event)"
								@focus="$event.target.select()">
							</spot-checkbox>
						</div>
						<ion-label color="tertiary" v-if="isActingDb">{{isWaitingActingDbText}}</ion-label>
						<div class="flex-row-center-container">
							<!--
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="undoText"
								@clicked="closeModal(false)">
							</spot-button>
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="!isEmptyRequiredPickFields && modalReadOnly == false"
								:expand="null"
								:text="confirmText"
								@clicked="closeModal(true)">
							</spot-button>
							-->
							<ion-button fill="outline" size="large" color="primary" :disabled="false" @click="closeModal(false)">
								<ion-spinner v-if="isActingDb"></ion-spinner>
								<span v-else>{{ undoText }}</span>
							</ion-button>
							<ion-button fill="outline" size="large" color="primary" :disabled="isEmptyRequiredPickFields == true || modalReadOnly == true || isActingDb == true" @click="closeModal(true)">
								<ion-spinner v-if="isActingDb"></ion-spinner>
								<span v-else>{{ confirmText }}</span>
							</ion-button>
						</div>
					</ion-content>
				</ion-modal>
				<ion-modal class="modal-settings" ref="newItem" backdrop-dismiss="false" :is-open="isOpenNewItem" @didDismiss="newItemDismissed">
					<ion-content>
						<ion-toolbar>
							<ion-title> {{ modalTitle }}</ion-title>
						</ion-toolbar>
						<div v-for="field in itemContents" :key="field.id">
							<spot-input
								v-if="(field.inputType == 'text' || field.inputType == 'number')"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:placeholder="getPlaceHolder(field)"
								:enabled="getEnabledItems(field, field.enabled)"
								:validationState="field.validationState"
								:furtherInfo="field.furtherInfo"
								:value="field.value"
								:type="field.inputType"
								@textChanged="changedNewItemTextField(field.id, $event)">
							</spot-input>
							<ion-textarea
								v-if="field.inputType == 'area'"
								:ref="field.name"
								:placeholder="getPlaceHolder(field)"
								:required="field.required"
								:disabled="!getEnabledItems(field, field.enabled)"
								:auto-grow="true"
								:value="field.value">
							</ion-textarea>
							<spot-checkbox
								v-if="field.inputType == 'check'"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:enabled="getEnabledItems(field, field.enabled)"
								:validationState="field.validationState"
								:value="field.value"
								@checkboxChanged="changedNewItemCheckboxField(field.id, $event)"
								@focus="$event.target.select()">
							</spot-checkbox>
							<spot-select
								v-if="field.inputType == 'select'"
								:ref="field.name"
								:label="field.text"
								:allignLabel="field.allignLabel"
								:required="field.required"
								:placeholder="getPlaceHolder(field)"
								:enabled="getEnabledItems(field, field.enabled)"
								:enabledExtraButtons="getEnabledItems(field, field.enabledExtraButtons)"
								:validationState="field.validationState"
								:value="field.value"
								:options="getOptions(field)"
								:optionField="field.refField"
								:canAddItem="field.canAddItem"
								:canRefreshList="field.canRefresh"
								:canUnlock="field.canUnlock"
								:selectedLabel="selectedText"
								:deselectLabel="deselectText"
								:selectLabel="selectText"
								@selected="assignedNewItemSelectField(field.id, $event)"
								@unselected="resetNewItemSelectField(field.id)">
							</spot-select>
						</div>
						<div class="flex-row-center-container">
							<!--
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="undoText"
								@clicked="closeNewItem(false)">
							</spot-button>
							<spot-button
								fill="outline"
								size="large"
								color="primary"
								:enabled="!isEmptyRequiredItemFields && modalReadOnly == false"
								:expand="null"
								:text="confirmText"
								@clicked="closeNewItem(true)">
							</spot-button>
							-->
							<ion-button fill="outline" size="large" color="primary" :disabled="false" @click="closeNewItem(false)">
								<ion-spinner v-if="isActingDb"></ion-spinner>
								<span v-else>{{ undoText }}</span>
							</ion-button>
							<ion-button fill="outline" size="large" color="primary" :disabled="isEmptyRequiredItemFields == true || modalReadOnly == true || isActingDb == true" @click="closeNewItem(true)">
								<ion-spinner v-if="isActingDb"></ion-spinner>
								<span v-else>{{ confirmText }}</span>
							</ion-button>
						</div>
					</ion-content>
				</ion-modal>
				<ion-modal class="alert-settings" ref="alert" backdrop-dismiss="false" :is-open="isOpenAlert" @didDismiss="alertDismissed">
					<ion-content>
						<ion-toolbar>
							<ion-title> {{ confirmDeleteTitle }}</ion-title>
						</ion-toolbar>
						<div class="wrapper">
							<ion-label class="ion-text-wrap">{{ !isPicking ? confirmDeletePickMessage : confirmDeleteProjectRowsMessage }}</ion-label>
							<br>
							<ion-label class="ion-text-wrap">{{	(tablesData.currentPick && tablesData.currentPick.item) ? tablesData.currentPick.item.description : '' }}</ion-label>
						</div>
						<div class="flex-row-center-container">
							<spot-button
								fill="outline"
								size="small"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="undoText"
								@clicked="closeAlert(false)">
							</spot-button>
							<spot-button
								fill="outline"
								size="small"
								color="primary"
								:enabled="true"
								:expand="null"
								:text="confirmText"
								@clicked="closeAlert(true)">
							</spot-button>
						</div>
					</ion-content>
				</ion-modal>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.debug">
				<div>Test Area</div>
				<spot-button
					fill="outline"
					size="large"
					color="primary"
					:enabled="true"
					text="Simulate Scan"
					@clicked="onReadedBarcode('8005892349727','barcode')">
				</spot-button>
				<div v-for="field in fields" :key="field.id">
					{{ field.name }} = {{ field.value }}
				</div>
			</div>
		</ion-content>

 </ion-page>
</template>

<style scoped>
	.modal-settings {
		--height: 80%;
		--width: 90%;
		--border-radius: 16px;
		--box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
	}
	.alert-settings {
		--height: 50%;
		--width: 90%;
		--border-radius: 16px;
		--box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
	}
	.wrapper {
		padding-left: 3vw;
		padding-right: 3vw;
	}
	ion-modal::part(backdrop) {
		background: var(--ion-color-medium);
		opacity: 1;
	}
	ion-modal ion-toolbar {
		--background: var(--ion-color-primary);
		--color: white;
	}
	ion-textarea {
		font-size: 12px;
		margin-top: 5px;
		margin-bottom: 0px;
		--padding-top: 0px;
		--padding-bottom: 0px;
		--inner-padding-top: 0px;
		--inner-padding-bottom: 0px;
		--min-height: 0px
	}
	.flex-row-center-container {
		margin-top: 0.2em;
		text-align: center;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
	.no-pad {
		margin-top: 0px;
		margin-bottom: 0px;
		--padding-top: 0px;
		--padding-bottom: 0px;
		--inner-padding-top: 0px;
		--inner-padding-bottom: 0px;
		--min-height: 0px
	}
	*:deep(ion-checkbox) {
		margin-top: 0px;
		margin-bottom: 0px;
	}
</style>
<style>
	.empty-row  {
		--easy-table-body-row-background-color: var(--ion-color-danger); /*#f56c6c;*/
	}
	.partial-row  {
		--easy-table-body-row-background-color: var(--ion-color-warning); /*#ddc229;*/
	}
	.completed-row  {
		--easy-table-body-row-background-color: var(--ion-color-success); /*#67c23a;*/
	}
	.exceeded-row  {
		--easy-table-body-row-background-color: var(--ion-color-tertiary);/*#0d9de0;*/
	}
	.prominence-column {
		font-size: 20px;
	}
</style>

<script>
import { IonButton, IonContent, IonIcon, IonItem, IonLabel, IonModal, IonPage, IonProgressBar, IonTextarea, IonTitle, IonToolbar, IonSpinner } from '@ionic/vue';
import { brush, duplicate, trash } from 'ionicons/icons';
import { defineComponent } from 'vue';
import SpotButton from '../components/SpotButton.vue';
import SpotCheckbox from '../components/SpotCheckbox.vue';
import SpotSelect from '../components/SpotSelect.vue';
import SpotInput from '../components/SpotInput.vue';
import SpotHeader from "../components/SpotHeader.vue";
import WebSocketReader from '../components/WebSocketReader.vue';
import { checkUserSession, confirmYesNo, settings, showMsgError, showMsgInfo, showMsgWarning, writeLog } from '../plugins/common.js';
import { getBarcodeToSearch } from '../plugins/gs1Ai.js';
import { createPick, createProjectRow, deleteProjectRow, deletePick, /*getItem,*/ getItems, getPick, getProject, getProjectRow, searchAdditionalBarcode, searchItem, searchPicks, searchProjectRows, tablesData, updateProjectRow, updatePick, updateProject } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "ManageStoreSupply",
		props: {
			pageTitle: { type: String, default: 'Gestisci Prelievo' },
			supplyTitle: { type: String, default: 'Approvvigionamento' },
			pickingTitle: { type: String, default: 'Prelievo' },
			noItemsText: { type: String, default: 'Nessun Articolo presente' },
			newItemText: { type: String, default: 'Nuovo' }, //'Nuovo Articolo'
			editItemText: { type: String, default: 'Modifica Articolo'}, //'Modifica Articolo: '
			showItemText: { type: String, default: 'Visualizza Articolo'}, //'Visualizza Articolo: '
			isWaitingItemsText: { type: String, default: 'Caricamento Articoli... Attendere'},
			isWaitingActingDbText: { type: String, default: 'Aggiornamento liste in corso... Attendere'},
			suspendText: { type: String, default: 'Esci/Sospendi' },
			closeText: { type: String, default: 'Concludi' },
			undoText: { type: String, default: 'Annulla' },
			confirmText: { type: String, default: 'Conferma' },
			unselected: { type: String, default: 'Nessuno' },
			selectedText: { type: String, default: 'Selezionato' },
			deselectText: { type: String, default: 'annulla' },
			selectText: { type: String, default: 'seleziona' },
			messageSearchItemTitle: { type: String, default: 'Ricerca Articolo' },
			messageSearchItemNotFound: { type: String, default: 'Articolo non trovato!' + '<br>' + 'Codice letto: ' },
			messageTitleCheckTAG: { type: String, default: 'Controllo TAG' },
			warnMultipleTAG: { type: String, default: 'Letto più di un TAG. Avvicinarsi solo al TAG da leggere e riprovare' },
			warnInavlidTAG: { type: String, default: 'TAG letto solo in parte. Riprovare a leggere' },
			confirmDeleteTitle: { type: String, default: 'Conferma Cancellazione' },
			confirmDeletePickMessage: { type: String, default: 'Confermi di voler eliminare l\'articolo corrente dall\'approvigionamento?' },
			confirmDeleteProjectRowMessage: { type: String, default: 'Confermi di voler eliminare la lettura dell\'articolo corrente?' },
			confirmDeleteProjectRowsMessage: { type: String, default: 'Confermi la cancellazione delle letture effettuate per l\'articolo corrente?' },
			messageTitleReader: { type: String, default: 'Lettura Barcode/TAG' },
			errorReadingReader: { type: String, default: 'Errore nella lettura del barcode/tag' },
			messageTitleGs1: { type: String, default: 'Controllo GS1' },
			warnInvalidGs1: { type: String, default: 'Il codice letto non è un GS1 valido o non contiene il GTIN (01)!' + '<br>' + 'Codice letto: ' },
			confirmExitTitle: { type: String, default: 'Conferma Uscita' },
			confirmExitMessage: { type: String, default: 'Sospensione! Se confermi l\'uscita, il prelievo verrà sospeso e potrà essere riaperto successivamente. Confermi?' },
			confirmCloseMessage: { type: String, default: 'Prelievo parziale! Confermi comunque la chiusura dell\'attività di prelievo?' }, // 'Confermi l\'uscita anche se non sono stati inseriti tutti i dati?'
			messageTitleInvalidQuantity: { type: String, default: "Quantità non valida" },
			warnExceededQuantity: { type: String, default: 'La Quantità inserita sommata alla Quantità rilevata in precedenza è superiore alla Quantità Prevista!' },
			warnNegativeQuantity: { type: String, default: 'Non è consentito inserire valori negativi nel campo Quantità!' },
			confirmItemChangeTitle: { type: String, default: 'Conferma Cambio Articolo' },
			confirmItemChangeMessage: { type: String, default: 'Confermi di voler sostituire l\'articolo corrente?' },
		},
		components: {
			IonPage,
			IonContent,
			IonProgressBar,
			IonItem,
			IonButton,
			IonSpinner,
			IonIcon,
			IonLabel,
			IonModal,
			IonToolbar,
			IonTitle,
			IonTextarea,
			SpotHeader,
			SpotInput,
			SpotCheckbox,
			SpotSelect,
			SpotButton,
			WebSocketReader,
		},
		data: () => ({
			isActive: null,
			field: {
				search: 0,
			},
			fields: [
				{ id: 0, name: 'search', text: 'Cerca: ', allignLabel: true, placeholder: 'Cerca Articolo', inputType: 'text', defaultValue: '', value: null, required: false, refField: null },
			],
			searchFields: ['item.code','item.description'],
			headers: [
				{ text: 'Descrizione', value: 'item.description', sortable: true },
				{ text: 'Azioni', value: 'actions', sortable: false }
				/*
				// { text: 'Ubicazione', value: 'location.name', sortable: true },
				{ text: 'Articolo', value: 'item.code', sortable: true },
				{ text: 'UM', value: 'item.measure_unit.name', sortable: false },
				{ text: 'Previsti', value: 'quantity', sortable: false },
				{ text: 'Rilevati', value: 'quantity_detected', sortable: false },
				// { text: 'Azioni', value: 'actions', sortable: false }
				*/
			],
			sortType: ['asc', 'asc'],
			sortBy: ['item.location.name','item.code'],
			pickContent: {
				id: 0,
				code: 1,
				description: 2,
				// measureUnit: 3,
				location:	3,
				stock: 4,
				expectedQuantity: 5,
				quantity: 6,
			},
			pickContents: [
				{ id: 0, name: 'id', text: 'Id', enabled: false, placeholder: 'Inserisci ID', inputType: "number", defaultValue: null, allignLabel: true, value: null, required: false, furtherInfo: null, validationState: null },
				{ id: 1, name: 'code', text: 'Articolo', enabled: false, placeholder: 'Inserisci Codice Articolo', inputType: 'text', defaultValue: null, allignLabel: true, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 2, name: 'description', text: 'Descrizione', enabled: false, placeholder: 'Inserisci Descrizione', inputType: 'area', defaultValue: null, allignLabel: false, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 3, name: 'measureUnit', text: 'Unità di Misura', enabled: false, placeholder: 'Inserisci Unità di misura', inputType: "text", validationState: null, defaultValue: null, allignLabel: true, value: null, required: true, furtherInfo: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 3, name: 'location', text: 'Ubicazione', enabled: false, placeholder: 'Inserisci Ubicazione', inputType: "text", validationState: null, defaultValue: null, allignLabel: true, value: null, required: true, furtherInfo: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 4, name: 'stock', text: 'Giacenza', enabled: false, placeholder: 'Inserisci Giacenza', inputType: 'number', defaultValue: null, allignLabel: true, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 5, name: 'expectedQuantity', enabled: true, text: 'Quantità da Prelevare', placeholder: 'Inserisci Quantità da Prelevare', inputType: 'number', defaultValue: null, allignLabel: false, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 6, name: 'quantity', text: 'Quantità Prelevata', enabled: false, placeholder: 'Inserisci Quantità Prelevata', inputType: 'number',  defaultValue: null, allignLabel: true, value: null, required: false, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
			],
			itemContent: {
				// search: 0,
				// id: 0,
				code: 0, // 2,
				description: 1, // 3,
				// measureUnit: 3,
				location: 2,
				stock: 3,
				expectedQuantity: 4, // 4
				quantity: 5, // 5
			},
			itemContents: [
				// { id: 0, name: 'search', text: 'Cerca', placeholder: 'Cerca Articolo', inputType: "select", enabled: true, enabledExtraButtons: false, allignLabel: true, validationState: null, furtherInfo: null, defaultValue: null, value: null, required: false, refField: 'description', canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 0, name: 'id', text: 'Id', enabled: false, placeholder: 'Inserisci ID', inputType: "number", validationState: null, defaultValue: null, value: null, required: true },
				// { id: 2, name: 'code', text: 'Codice', enabled: false, placeholder: 'Inserisci Codice', inputType: "text", validationState: null, defaultValue: null, value: null, required: true },
				{ id: 0, name: 'code', text: 'Articolo', enabled: false, allignLabel: true, placeholder: 'Inserisci Codice Articolo', inputType: 'text', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 3, name: 'description', text: 'Descrizione', enabled: false, placeholder: 'Inserisci Descrizione', inputType: "text", validationState: null, defaultValue: null, value: null, required: true },
				{ id: 1, name: 'description', text: 'Descrizione', enabled: false, allignLabel: false, placeholder: 'Inserisci Descrizione', inputType: 'area', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 2, name: 'measureUnit', text: 'Unità di Misura', enabled: false, allignLabel: true, placeholder: 'Inserisci Unità di misura', inputType: "text", validationState: null, defaultValue: null, value: null, required: true },
				{ id: 2, name: 'location', text: 'Ubicazione', enabled: false, allignLabel: true, placeholder: 'Inserisci Ubicazione', inputType: "text", defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				{ id: 3, name: 'stock', text: 'Giacenza', enabled: false, allignLabel: true, placeholder: 'Inserisci Giacenza', inputType: 'number', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 4, name: 'expectedQuantity', text: 'Quantità Prevista', enabled: false, placeholder: 'Inserisci Quantità Prevista', inputType: "number", validationState: null, defaultValue: null, value: null, required: true },
				{ id: 4, name: 'expectedQuantity', text: 'Quantità da Prelevare', enabled: true, allignLabel: false, placeholder: 'Inserisci Quantità da Prelevare', inputType: 'number', defaultValue: null, value: null, required: true, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
				// { id: 5, name: 'quantity', text: 'Quantità Rilevata', enabled: true, placeholder: 'Inserisci Quantità Rilevata', inputType: "number", validationState: null, defaultValue: null, value: null, required: true },
				{ id: 5, name: 'quantity', text: 'Quantità Prelevata', enabled: false, allignLabel: true, placeholder: 'Inserisci Quantità Prelevata', inputType: 'number',  defaultValue: null, value: null, required: false, furtherInfo: null, validationState: null, canAddItem: false, canRefresh: false, canUnlock: false },
			],
			default_location_id: 1,
			isOpenModal: false,
			isOpenNewItem: false,
			isOpenAlert: false,
			isWaitingItems: false,
			modalTitle: null,
			modalReadOnly: null,
			actionDbCreate: null,
			isPicking: null,
			isRevision: null,
			isLocked: null,
			projectId: null,
			lastBarcode: null,
			lastGs1: null,
			lastTag: null,
			assignRemaingQuantity: false,
			allowExceededQuantity: true,
			allowNegativeQuantity: false,
			isStartedRowDeleteAction: false,
			isActingDb: false,
			duplicate,
			trash,
			brush,
			settings,
			checkUserSession,
			confirmYesNo,
			showMsgError,
			showMsgInfo,
			showMsgWarning,
			writeLog,
			getBarcodeToSearch,
			// getItem,
			getItems,
			getPick,
			getProject,
			getProjectRow,
			searchAdditionalBarcode,
			searchItem,
			searchPicks,
			searchProjectRows,
			createPick,
			createProjectRow,
			updatePick,
			updateProject,
			updateProjectRow,
			deletePick,
			deleteProjectRow,
			tablesData,
		}),
		async ionViewWillEnter() {
			this.getUrlParamsAndQuery();
			this.setDefault();
			await this.getAllTablesData();
			this.isActive = true;
		},
		ionViewWillLeave() {
			this.isOpenModal = false;
			this.isOpenNewItem = false;
			this.isOpenAlert = false;
			this.isWaitingItems = false;
			this.isActive=false;
		},
		computed: {
			isEmptyRequiredPickFields() {
				let ret = false;
				this.pickContents.forEach(element => {if (element.required && !element.value && element.id > 0) ret=true});
				return ret;
			},
			isEmptyRequiredItemFields() {
				let ret = false;
				this.itemContents.forEach(element => {if (element.required && !element.value && element.id > 0) ret=true});
				return ret;
			},
			/*
			isOrderClean() {
				let ret = true;
				this.tablesData.picks.forEach(element => {if (element.quantity_detected > 0) ret=false});
				return ret;
			},
			isOrderFinished() {
				let ret = true;
				this.tablesData.picks.forEach(element => {if (element.quantity != element.quantity_detected) ret=false});
				return ret;
			},
			*/
			checkQuantity() {
				let ret = true;
				if (!this.allowNegativeQuantity) {
					if ((parseFloat(this.pickContents[this.pickContent.quantity].value)) < parseFloat(0)) {
						this.showMsgWarning(this.messageTitleInvalidQuantity, this.warnNegativeQuantity);
						ret = false;
					}
				}
				if (ret == true && !this.allowExceededQuantity) {
					if ((parseFloat(this.tablesData.currentPick.quantity_detected) + parseFloat(this.pickContents[this.pickContent.quantity].value)) > parseFloat(this.tablesData.currentPick.quantity)) {
						this.showMsgWarning(this.messageTitleInvalidQuantity, this.warnExceededQuantity);
						ret = false;
					}
				}
				return ret;
			},
		},
		setup() {
			const bodyRowClassNameFunction = (item) => {
				if (parseFloat(item.quantity_detected) == parseFloat(item.quantity)) return 'completed-row'
				else if(parseFloat(item.quantity_detected) == parseFloat(0)) return 'empty-row'
				else if(parseFloat(item.quantity_detected) < parseFloat(item.quantity)) return 'partial-row'
				else return 'exceeded-row';
			}
			const bodyItemClassNameFunction = (column) => {
				if (column === 'quantity' || column === 'quantity_detected') return 'prominence-column';
				else return '';
			};
			return {
				bodyRowClassNameFunction,
				bodyItemClassNameFunction,
			};
		},
		methods: {
			// Settings & StartUp
			getUrlParamsAndQuery() {
				this.isPicking = (/true/i).test(this.$route.query.picking);
				this.isRevision = (/true/i).test(this.$route.query.revision);
				this.isLocked = (/true/i).test(this.$route.query.locked);
				this.projectId = this.$route.params.id;
			},
			setDefault() {
				this.fields.forEach(element => element.value = element.defaultValue);
				this.isOpenModal = false;
				this.isOpenNewItem = false;
				this.isOpenAlert = false;
				this.isWaitingItems = false;
				this.modalTitle = null;
				this.modalReadOnly = null;
				this.actionDbCreate = null;
				this.lastBarcode = null;
				this.lastGs1 = null;
				this.lastTag = null;
				this.isStartedRowDeleteAction = false;
				this.isActingDb = false
			},
			getPlaceHolder(element) {
				return ((this.settings.showFieldsPlaceholder) ? (element.required ? element.placeholder : this.unselected ) : '')
			},
			getEnabledItems(element, defaultState) {
				let ret = false;
				// if(this.isActive == true) {
				if (defaultState != null) ret = defaultState;
				else {
					switch (element.id) {
						case this.itemContent.code:
							ret = !!this.itemContents[this.itemContent.code].value
							break;
						case this.itemContent.confirm:
							// ret = !!this.projectField.value && !! this.locationField.value
							ret = !this.isEmptyRequiredItemFields
							break;
					}
				}
				// }
				return ret
			},
			getEnabledPicks(element, defaultState) {
				let ret = false;
				// if(this.isActive == true) {
				if (defaultState != null) ret = defaultState;
				else {
					switch (element.id) {
						case this.pickContent.code:
							ret = !!this.pickContents[this.pickContent.code].value
							break;
						case this.pickContent.confirm:
							// ret = !!this.projectField.value && !! this.locationField.value
							ret = !this.isEmptyRequiredPickFields
							break;
					}
				}
				// }
				return ret
			},
			getOptions(element) {
				let ret = false;
				// if(this.isActive == true) {
				switch (element.id) {
					case this.itemContent.search:
						ret = this.tablesData.items
						break;
				}
				// }
				return ret
			},
			// Database
			async getAllTablesData(isFirstLoad = true) {
				if (isFirstLoad) {
					await this.getProject(this.projectId);
				}
				// this.tablesData.projectRows = [];
				this.tablesData.picks = [];
				// await this.searchProjectRows(this.projectId);
				await this.searchPicks(this.projectId);
				// await this.getLocations();
				// if (this.tablesData.locations.length > 0) {this.default_location_id = this.tablesData.locations[0].id };
			},
			async deleteExistingPick(pick) {
				this.isStartedRowDeleteAction = true;
				let canDelete = false;
				await this.confirmYesNo(this.confirmDeleteTitle, this.confirmDeletePickMessage)
					.then((data) => { canDelete = data })
				if (canDelete == true) {
					await this.deletePick(pick.id, false)
				}
				await this.getAllTablesData(false);
				this.isStartedRowDeleteAction = false;
			},
			async deleteExistingProjectRow(projectRow) {
				let canDelete = false;
				await this.confirmYesNo(this.confirmDeleteTitle, this.confirmDeleteProjectRowMessage)
					.then((data) => { canDelete = data })
				if (canDelete == true) {
					await this.deleteProjectRow(projectRow.id, false)
				}
			},
			async deleteProjectRowsInPick(pick) {
				this.isStartedRowDeleteAction = true;
				let canDelete = false;
				await this.confirmYesNo(this.confirmDeleteTitle, this.confirmDeleteProjectRowsMessage)
				.then((data) => { canDelete = data })
				if (canDelete == true) {
					for (let i = 0; i < pick.project_rows.length; i++) {
						await this.deleteProjectRow(pick.project_rows[i].id, false)
					}
				}
				await this.getAllTablesData();
				this.isStartedRowDeleteAction = false;				
			},
			// Actions
			async onReadedBarcode(barcode, type, gs1Data = null) {
				this.writeLog(barcode, type, gs1Data);
				let barcodeToSearch = this.getBarcodeToSearch(barcode, type, gs1Data, this.settings.manageGs1Ai);
				this.lastBarcode = barcodeToSearch.barcode;
				this.lastGs1 = barcodeToSearch.gs1Data;
				if (barcodeToSearch.result == false) {
					this.showMsgWarning(this.messageTitleGs1, this.warnInvalidGs1 + barcode);
					return;
				}
				await this.committedBarcode();
			},
			async onReadedTag(tag,type) {
				this.lastTag = tag;
				this.writeLog(tag, type);
				await this.committedTag();
			},
			onReaderError(data,error) {
				this.showMsgError(data, error);
				this.showMsgWarning(this.messageTitleReader, this.errorReadingReader);
			},
			changedSearch(value) {
				this.fields[this.field.search].value = value;
			},
			changedTextField(fieldId, value) {
				this.pickContents[fieldId].value = value;
				(!value || value.length == 0)? this.pickContents[fieldId].validationState = false : this.pickContents[fieldId].validationState = true
			},
			changedCheckboxField(fieldId, value) {
				this.pickContents[fieldId].value = value;
				(!value || value.length == 0)? this.pickContents[fieldId].validationState = false : this.pickContents[fieldId].validationState = true
			},
			changedNewItemTextField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value || value.length == 0)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
			},
			changedNewItemCheckboxField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value || value.length == 0)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
			},
			assignedNewItemSelectField(fieldId, value) {
				this.itemContents[fieldId].value = value;
				(!value)? this.itemContents[fieldId].validationState = false : this.itemContents[fieldId].validationState = true
				this.itemContents[this.itemContent.code].value = value.code;
				this.itemContents[this.itemContent.description].value = value.description
				this.itemContents[this.itemContent.expectedQuantity].value = value.quantity
				this.itemContents[this.itemContent.expectedQuantity].furtherInfo = value.measure_unit.name
				this.itemContents[this.itemContent.quantity].value = null
				this.itemContents[this.itemContent.quantity].furtherInfo = value.measure_unit.name
			},
			resetNewItemSelectField(fieldId) {
				this.itemContents[fieldId].value = null;
				this.itemContents[fieldId].validationState = false
			},
			prepareNewPickFromItems() {
				let myRecord = {
					picks: {
						project_id: this.projectId, // this.tablesData.currentProject.id
						location_id: this.default_location_id, // this.tablesData.currentLocation.id
						item_id: this.tablesData.currentItem.id, // this.itemContents[this.itemContent.code].value.id, // this.itemContents[this.itemContent.search].value.id
						quantity: this.itemContents[this.itemContent.expectedQuantity].value,
					}
				};
				return myRecord;
			},
			prepareNewProjectRowFromItems() {
				let myRecord = {
					project_rows: {
						project_id: this.projectId, // this.tablesData.currentProject.id
						location_id: this.default_location_id, // this.tablesData.currentLocation.id
						pick_id: this.tablesData.currentPick.id,
						item_id:  this.tablesData.currentItem.id, //this.itemContents[this.itemContent.search].value.id, // this.itemContents[this.itemContent.search].value.id
						quantity: this.itemContents[this.itemContent.quantity].value,
					}
				};
				return myRecord;
			},
			prepareNewProjectRow() {
				let myRecord = {
					project_rows: {
						project_id: this.tablesData.currentPick.project_id, // this.projectId
						pick_id: this.tablesData.currentPick.id,
						location_id: this.tablesData.currentPick.location.id,
						item_id: this.tablesData.currentPick.item.id,
						quantity: this.itemContents[this.itemContent.quantity].value,
					}
				};
				this.writeLog(myRecord.project_rows);
				return myRecord;
			},
			prepareUpdatePickQuantity() {
				let myRecord = {
					picks: {
						quantity: this.pickContents[this.pickContent.expectedQuantity].value,
					}
				};
				return myRecord;
			},
			prepareUpdateProjectRowQuantity() {
				let myRecord = {
					project_rows: {
						quantity: this.pickContents[this.pickContent.quantity].value,
					}
				};
				return myRecord;
			},
			prepareUpdatePickClosedFlag(isClosed) {
				let myRecord = {
					picks: {
						closed: isClosed,
					}
				};
				return myRecord;
			},
			updateItemContents(row) {
				Object.getOwnPropertyNames(row).forEach(rowField => {
					this.itemContents.forEach(pageElement => {
						if (rowField == pageElement.name) {
							pageElement.value = row[rowField];
						}
					});
				});
			},
			createNewCustomItemContents(itemRow) {
				this.itemContents[this.itemContent.code].value = itemRow.code
				this.itemContents[this.itemContent.description].value = itemRow.description
				// this.itemContents[this.itemContent.measureUnit].value = itemRow.measure_unit.name
				this.itemContents[this.itemContent.location].value = itemRow.location.name
				this.itemContents[this.itemContent.location].furtherInfo = (itemRow.locations.length > 0)? itemRow.locations.map((element) => element.name) + '': null
				this.itemContents[this.itemContent.stock].value = itemRow.quantity
				this.itemContents[this.itemContent.stock].furtherInfo = (itemRow.locked_quantity > 0)? ' (Disponibili: ' + (parseFloat(itemRow.quantity) - parseFloat(itemRow.locked_quantity)) + ')': null
				this.itemContents[this.itemContent.expectedQuantity].value = null
				this.itemContents[this.itemContent.expectedQuantity].furtherInfo = itemRow.measure_unit.name
				this.itemContents[this.itemContent.quantity].value = null
				this.itemContents[this.itemContent.quantity].furtherInfo = itemRow.measure_unit.name
				//this.itemContents[this.itemContent.quantity].furtherInfo = null
			},
			createCustomItemContents(pickRow) {
				this.itemContents[this.itemContent.code].value = pickRow.item.code
				this.itemContents[this.itemContent.description].value = pickRow.item.description
				// this.itemContents[this.itemContent.measureUnit].value = pickRow.item.measure_unit.name
				this.itemContents[this.itemContent.location].value = pickRow.item.location.name
				this.itemContents[this.itemContent.location].furtherInfo = (pickRow.item.locations.length > 0)? pickRow.item.locations.map((element) => element.name) + '': null
				this.itemContents[this.itemContent.stock].value = pickRow.item.quantity
				this.itemContents[this.itemContent.stock].furtherInfo = (pickRow.item.locked_quantity > 0)? ' (Disponibili: ' + (parseFloat(pickRow.item.quantity) - parseFloat(pickRow.item.locked_quantity)) + ')': null
				this.itemContents[this.itemContent.expectedQuantity].value = pickRow.quantity
				this.itemContents[this.itemContent.expectedQuantity].furtherInfo = (pickRow.quantity_detected > 0)? ' (Già inseriti: ' + parseFloat(pickRow.quantity_detected) + ')': null
				this.itemContents[this.itemContent.quantity].value = (!this.assignRemaingQuantity)? null : (parseFloat(pickRow.quantity) - parseFloat(pickRow.quantity_detected))
				this.itemContents[this.itemContent.quantity].furtherInfo = pickRow.item.measure_unit.name
				//this.itemContents[this.itemContent.quantity].furtherInfo = ' / ' + (parseFloat(pickRow.quantity) - parseFloat(pickRow.quantity_detected))
			},
			updateCustomPickContents(pickRow) {
				this.pickContents[this.pickContent.id].value = pickRow.id
				this.pickContents[this.pickContent.code].value = pickRow.item.code
				this.pickContents[this.pickContent.description].value = pickRow.item.description
				// this.pickContents[this.pickContent.measureUnit].value = pickRow.item.measure_unit.name
				this.pickContents[this.pickContent.stock].value = pickRow.item.quantity
				this.pickContents[this.pickContent.stock].furtherInfo = (pickRow.item.locked_quantity > 0)? ' (Disponibili: ' + (parseFloat(pickRow.item.quantity) - parseFloat(pickRow.item.locked_quantity)) + ')': null
				this.pickContents[this.pickContent.location].value = pickRow.item.location.name
				this.pickContents[this.pickContent.location].furtherInfo = (pickRow.item.locations.length > 0)? pickRow.item.locations.map((element) => element.name) + '': null
				this.pickContents[this.pickContent.expectedQuantity].value = parseInt(pickRow.quantity)
				this.pickContents[this.pickContent.expectedQuantity].furtherInfo = pickRow.item.measure_unit.name
				this.pickContents[this.pickContent.quantity].value = parseInt(pickRow.project_rows[0].quantity) //parseInt(pickRow.quantity_detected)
				this.pickContents[this.pickContent.quantity].furtherInfo = pickRow.item.measure_unit.name
			},
			updateCustomProjectRowContents(pickRow) {
				this.pickContents[this.pickContent.id].value = pickRow.project_rows[0].id
				this.pickContents[this.pickContent.code].value = pickRow.item.code
				this.pickContents[this.pickContent.description].value = pickRow.item.description
				// this.pickContents[this.pickContent.measureUnit].value = pickRow.item.measure_unit.name
				this.pickContents[this.pickContent.stock].value = pickRow.item.quantity
				this.pickContents[this.pickContent.stock].furtherInfo = (pickRow.item.locked_quantity > 0)? ' (Disponibili: ' + (parseFloat(pickRow.item.quantity) - parseFloat(pickRow.item.locked_quantity)) + ')': null
				this.pickContents[this.pickContent.location].value = pickRow.item.location.name
				this.pickContents[this.pickContent.location].furtherInfo = (pickRow.item.locations.length > 0)? pickRow.item.locations.map((element) => element.name) + '': null
				this.pickContents[this.pickContent.expectedQuantity].value = parseInt(pickRow.quantity)
				this.pickContents[this.pickContent.expectedQuantity].furtherInfo = pickRow.item.measure_unit.name
				this.pickContents[this.pickContent.quantity].value = parseInt(pickRow.project_rows[0].quantity) //parseInt(pickRow.quantity_detected)
				this.pickContents[this.pickContent.quantity].furtherInfo = pickRow.item.measure_unit.name
			},
			async createNewPickAndProjectRowFromItems(itemRow) {
				if (!this.isStartedRowDeleteAction) {
					if (this.tablesData.items.length == 0 && !itemRow) {
						this.isWaitingItems = true;
						await this.getItems();
						this.isWaitingItems = false;
					}
					if (!itemRow) {
						this.itemContents.forEach(element => element.value = element.defaultValue);
					}
					else {
						this.tablesData.currentItem = itemRow;
						// await this.getItem(itemRow.id);
						this.createNewCustomItemContents(this.tablesData.currentItem);
					}
					this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
					this.modalTitle = this.newItemText;
					this.actionDbCreate = true;
					this.openNewItem(false);
				}
			},
			async tableItemClicked(tableRow) {
				if (!this.isPicking) {
					await this.editExistingPick(tableRow);
				}
				else {
					await this.editExistingProjectRow(tableRow);
				}
			},
			async createNewProjectRow(tableRow) {
				if (!this.isStartedRowDeleteAction) {
					this.writeLog(tableRow);
					if (!tableRow) {
						this.itemContents.forEach(element => element.value = element.defaultValue);
					}
					else {
						this.tablesData.currentPick = tableRow;
						await this.getPick(tableRow.id);
						this.createCustomItemContents(this.tablesData.currentPick);
					}
					this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
					this.modalTitle = this.newItemText;
					this.actionDbCreate = true;
					this.openModal(false);
				}
			},
			async editExistingPick(pick) {
				if (!this.isStartedRowDeleteAction) {
					this.tablesData.currentPick = pick;
					await this.getPick(pick.id);
					await this.getProjectRow(pick.project_rows[0].id);
					this.updateCustomPickContents(pick);
					this.pickContents[this.pickContent.expectedQuantity].required = true;
					this.pickContents[this.pickContent.expectedQuantity].enabled = true;
					this.pickContents[this.pickContent.quantity].required = false;
					this.pickContents[this.pickContent.quantity].enabled = false;
					this.pickContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
					this.modalTitle = this.editItemText // + pick.item.code;
					this.actionDbCreate = false;
					this.openModal(false);
				}
			},
			async editExistingProjectRow(pick) {
				if (!this.isStartedRowDeleteAction) {
					await this.getPick(pick.id);
					await this.getProjectRow(pick.project_rows[0].id);
					this.updateCustomProjectRowContents(pick);
					this.pickContents[this.pickContent.expectedQuantity].required = false;
					this.pickContents[this.pickContent.expectedQuantity].enabled = false;
					this.pickContents[this.pickContent.quantity].required = true;
					this.pickContents[this.pickContent.quantity].enabled = true;
					this.pickContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
					this.modalTitle = this.editItemText // + projectRow.item.code;
					this.actionDbCreate = false;
					this.openModal(false);
				}
			},
			async showExistingPick(pick) {
				if (!this.isStartedRowDeleteAction) {
					this.updateCustomItemContents(pick);
					this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
					this.modalTitle = this.showItemText // + pick.item.code;
					this.actionDbCreate = false;
					this.openModal(true);
				}
			},
			async showExistingProjectRow(projectRow) {
				if (!this.isStartedRowDeleteAction) {
					this.updateCustomItemContents(projectRow);
					this.itemContents.forEach(element => (element.required == true? (element.value == null && element.id > 0 ? element.validationState = false : element.validationState = true) : element.validationState = null));
					this.modalTitle = this.showItemText // + projectRow.item.code;
					this.actionDbCreate = false;
					this.openModal(true);
				}
			},
			openModal(isReadOnly) {
				this.modalReadOnly = isReadOnly;
				this.isOpenModal = true;
			},
			async closeModal(saveRecord) {
				let canCloseModal = true;
				this.isActingDb = true;
				if (saveRecord == true) {
					if (!this.isPicking) {
						if (this.actionDbCreate == true) {
							await this.createPick(this.prepareNewPickFromItems(), false)
							await this.createProjectRow(this.prepareNewProjectRowFromItems(), false)
						}
						else {
							await this.updatePick(this.pickContents[this.pickContent.id].value, this.prepareUpdatePickQuantity(), false)
						}
					}
					else {
						if (this.checkQuantity) {
							if (this.actionDbCreate == true) {
								await this.createProjectRow(this.prepareNewProjectRow(), false)
							}
							else {
								await this.updateProjectRow(this.pickContents[this.pickContent.id].value, this.prepareUpdateProjectRowQuantity(), false)
							}
						}
						else {
							canCloseModal = false;
						}
					}
				}
				if (canCloseModal) {
					await this.getAllTablesData();
					this.isOpenModal = false;
				}
				this.isActingDb = false;
			},
			async modalDismissed() {
				this.actionDbCreate = null;
			},
			async openAlert(tableRow) {
				this.isStartedRowDeleteAction = true;
				this.tablesData.currentPick = tableRow;
				await this.getPick(tableRow.id);
				if (this.isPicking) {
					await this.getProjectRow(tableRow.project_rows[0].id);
				}
				this.isOpenAlert = true;
			},
			async closeAlert(deleteRecord) {
				if (deleteRecord == true) {
					if (!this.isPicking) {
						await this.deletePick(this.tablesData.currentPick.id, false)
						await this.deleteProjectRow(this.tablesData.currentPick.project_rows[0].id, false)
					}
					else {
						for (let i = 0; i < this.tablesData.currentPick.project_rows.length; i++) {
							this.pickContents[this.pickContent.quantity].value = null
							await this.updateProjectRow(this.tablesData.currentPick.project_rows[i].id, this.prepareUpdateProjectRowQuantity(), false)
						}						
					}
					await this.getAllTablesData();
				}
				this.isStartedRowDeleteAction = false;
				this.isOpenAlert = false;
			},
			async alertDismissed() {
				this.actionDbCreate = null;
			},
			openNewItem(isReadOnly) {
				this.modalReadOnly = isReadOnly;
				this.isOpenNewItem = true;
			},
			async closeNewItem(saveRecord) {
				let canCloseNewItem = true;
				this.isActingDb = true;
				if (saveRecord == true) {
					if (!this.isPicking) {
						if (this.itemContents[this.itemContent.expectedQuantity].value > 0) {
							if (this.actionDbCreate == true) {
								await this.createPick(this.prepareNewPickFromItems(), false)
								await this.createProjectRow(this.prepareNewProjectRowFromItems(), false)
							}
						}
						else {
							canCloseNewItem = false;
						}
					}
				}
				if (canCloseNewItem) {
					await this.getAllTablesData(false);
					this.isOpenNewItem = false;
				}
				this.isActingDb = false;
			},
			async newItemDismissed() {
				this.actionDbCreate == null;
			},
			changedBarcode(value) {
				this.lastBarcode = value;
			},
			async searchBarcodeInProjectPicks() {
				let ret = null;
				this.tablesData.picks.some(element => {
					if (element.item.barcode == this.lastBarcode) {
						ret = element;
						return true;
					}
					if (element.item.additional_barcodes.length > 0) {
						element.item.additional_barcodes.some(subElement => {
							if (subElement.code == this.lastBarcode) {
								ret = element;
								return true;
							}
						})
					}
				});
				return ret;
			},
			async searchBarcodeInTables() {
				let ret = null;
				this.tablesData.currentItem = null;
				this.tablesData.currentAdditionalBarcode = null;
				await this.searchItem(null,this.lastBarcode);
				if (!this.tablesData.currentItem) {
					await this.searchAdditionalBarcode(this.lastBarcode);
					if (!this.tablesData.currentAdditionalBarcode) {
						this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound + this.lastBarcode);
					}
					else {
						ret = this.tablesData.currentAdditionalBarcode.item;
					}
				}
				else {
					ret = this.tablesData.currentItem;
				}
				return ret;
			},
			async committedBarcode() {
				let foundElement = null;
				if (this.isOpenModal == false && this.isOpenNewItem == false && this.isOpenAlert == false) {
					if (!this.isPicking) {
						foundElement = await this.searchBarcodeInProjectPicks();
						if (foundElement != null) {
							this.editExistingPick(foundElement)
						}
						else {
							foundElement = await this.searchBarcodeInTables();
							if (foundElement != null) {
								this.createNewPickAndProjectRowFromItems(foundElement)
								/*
								this.tablesData.currentPick.item = foundElement;
								this.itemContents[this.itemContent.code].value = foundElement.code
								this.itemContents[this.itemContent.code].validationState = true
								this.itemContents[this.itemContent.description].value = foundElement.description
								this.itemContents[this.itemContent.location].value = foundElement.location.name
								this.itemContents[this.itemContent.location].furtherInfo = (foundElement.locations.length > 0)? foundElement.locations.map((element) => element.name) + '': null
								this.itemContents[this.itemContent.stock].value = foundElement.quantity
								this.itemContents[this.itemContent.stock].furtherInfo = (foundElement.locked_quantity > 0)? ' (Disponibili: ' + (parseFloat(foundElement.quantity) - parseFloat(foundElement.locked_quantity)) + ')': null
								this.itemContents[this.itemContent.quantity].furtherInfo = foundElement.measure_unit.name
								*/
							}
						}
					}
					else {
						foundElement = await this.searchBarcodeInProjectPicks();
						if (!foundElement) this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound + this.lastBarcode);
						else await this.editExistingProjectRow(foundElement); // editExistingPick(foundElement);
					}
				}
			},
			changedTag(value) {
				this.lastTag = value;
			},
			async committedTag() {
				let tagElements = this.lastTag.split('|');
				let foundElement = null;

				switch (tagElements.length) {
					case 0:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnInavlidTAG);
						break;
					case 1:
						this.tablesData.picks.some(pick => {
							if (pick.item.code == this.lastTag) {
								foundElement = pick;
								return true;
							}
						});
						if (!foundElement) this.showMsgWarning(this.messageSearchItemTitle, this.messageSearchItemNotFound + this.lastTag);
						else this.editExistingPick(foundElement);
						break;
					default:
						this.lastTag = null;
						this.showMsgWarning(this.messageTitleCheckTAG,this.warnMultipleTAG);
						break;
				}
			},
			async createEmptyProjectRows() {
				let myRecord = {
					project_rows: {
						project_id: this.projectId,
						pick_id: null,
						location_id: null,
						item_id: null,
						quantity: 0,
					}
				};
				for (let i = 0; i < this.tablesData.picks.length; i++) {
					if (this.tablesData.picks[i].quantity_detected == 0) {
						myRecord.project_rows.pick_id = this.tablesData.picks[i].id;
						myRecord.project_rows.location_id = this.tablesData.picks[i].location.id,
						myRecord.project_rows.item_id = this.tablesData.picks[i].item.id,
						await this.createProjectRow(myRecord, false)
					}
				}
			},
			getProjectStatus() {
				let status = {
					closed: true,
					untouched: true,
				};
				this.tablesData.picks.forEach(element => {
					if (parseFloat(element.quantity_detected) > 0) status.untouched = false;
					if (!this.allowExceededQuantity) {
						if (parseFloat(element.quantity) != parseFloat(element.quantity_detected)) status.closed = false;
					}
					else {
						if (parseFloat(element.quantity) > parseFloat(element.quantity_detected)) status.closed = false;
					}
				});
				return status;
			},
			async updateProjectFlags(storeFlag = null, preparedFlag = null, partialFlag = null, suspendedFlag = null) {
				let myRecord = {
					project: {
					}
				};
				if (storeFlag != null) myRecord.project['store'] = storeFlag
				if (preparedFlag != null) myRecord.project['prepared'] = preparedFlag
				if (partialFlag != null) myRecord.project['partial'] = partialFlag
				if (suspendedFlag != null) myRecord.project['suspended'] = suspendedFlag
				await this.updateProject(this.projectId, myRecord, false);
			},
			async closeSupply() {
				let canExit = true;
				let projectsStatus = this.getProjectStatus();

				if (!this.isPicking) {
					await this.updateProjectFlags(true, false, false, false);
				}
				else if (projectsStatus.closed == true) {
					await this.updateProjectFlags(this.isPicking, true, false, false);
				}
				else if (projectsStatus.untouched == true) {
					canExit = false;
				}
				else {
					await this.confirmYesNo(this.confirmExitTitle, this.confirmCloseMessage)
					.then((data) => { canExit = data })
					if (canExit == true) {
						await this.createEmptyProjectRows();
						await this.updateProjectFlags(this.isPicking, true, true, false);
					}
				}

				if (canExit == true) {
					this.$router.push("/store/selection" + "?picking=" + this.isPicking);
				}
			},
			async exitSupply() {
				let canExit = true;
				let projectStatus = this.getProjectStatus();

				if (!this.isPicking) {
					await this.updateProjectFlags(null, null, false, true);
				}
				else if (projectStatus.untouched == true) {
					await this.updateProjectFlags(null, null, null, false);
				}
				else {
					await this.confirmYesNo(this.confirmExitTitle, this.confirmExitMessage)
					.then((data) => { canExit = data })
					if (canExit == true) {
						await this.updateProjectFlags(null, null, false, true);
					}
				}

				if (canExit == true) {
					this.$router.push("/store/selection" + "?picking=" + this.isPicking);
				}
			}
		}
	});
</script>
